import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";
import { RatingInput } from "@typings/GooglePlaces";

export function serializeRatingsQuery(items: RatingInput[]) {
  return {
    names: items.map((i) => i.restaurantName).join("|"),
    ids: items.map((i) => i.articleId).join(","),
  };
}

export function serializeServerRatingsQuery(articles: ProcessedArticleData[]) {
  const names = articles.map((a) => a.location?.title || "").join("|");

  const ids = articles.map((a) => a.id).join(",");

  return { names, ids };
}
